export enum AbTestVariant {
  Off = 'off',
  On = 'on',
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
}
